import React, { useEffect, useState } from 'react';
import { ApplicationRoles } from './api-authorization/ApiAuthorizationConstants';
import Button from 'react-bootstrap/Button';
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge"
import FixtureDetailsModal from './Modals/FixtureDetailsModal';
import liveRoomService from '../services/LiveRoomService';
import authorizeService from './api-authorization/AuthorizeService';
import { HubConnectionBuilder } from '@microsoft/signalr';

const LiveRooms = (props) => {
    const [userRole, setUserRole] = useState(null);
    const [liveRooms, setLiveRooms] = useState(null);
    const [connectionCounts, setConnectionCounts] = useState(null);
    const [loading, setLoading] = useState(true);
    const [connection, setConnection] = useState(null);

    const [show, setShow] = useState(false);

    const [selectedFixture, setSelectedFixture] = useState(null);

    useEffect(() => {
        if (!userRole) {
            authorizeService.getUserRole().then((role) => {
                setUserRole(role);
            });
        }
    }, []);

    useEffect(() => {
        if (!liveRooms) {
            liveRoomService.getLiveRooms().then((roomsResponse) => {
                setLiveRooms(roomsResponse.liveRooms);
                setConnectionCounts(roomsResponse.connectionCounts);
                setLoading(false);
            });
        }
    }, [liveRooms]);

    useEffect(() => {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;

        const connection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}/hubs/fixturerooms`, {accessTokenFactory: () => authorizeService.getAccessToken()})
            .withAutomaticReconnect()
            .build();

        setConnection(connection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    console.log('Connected!');

                    connection.on('RoomStart', message => {
                        liveRooms.push(message);
                        setLiveRooms(liveRooms);
                    });

                    connection.on('RoomCounts', message => {
                        console.log('RoomCounts');
                        console.log(message);
                        setConnectionCounts(message);
                    });

                    connection.on('RoomEnd', message => {
                        console.log('RoomEnd');
                        setLiveRooms(liveRooms.filter(x => x.fixtureRoomId != message.fixtureRoomId));
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);

    const hideModal = () => {
        setShow(false)
    }

    const renderModal = () => {
        if (selectedFixture) {
            return <FixtureDetailsModal
                show={show}
                onHide={hideModal}
                userRole={userRole}
                fixture={selectedFixture}>
            </FixtureDetailsModal>;
        } else
            return <></>;
    }

    const renderTable = (liveRooms) => {
        const isManager = userRole === ApplicationRoles.Manager;

        const content = liveRooms.length == 0 ? (
            <tr className="p-2">
                <td colSpan="5" className="text-center">No live matches</td>
            </tr>
        ) : (liveRooms.map((x) => {

            let connectedCount = connectionCounts[x.fixtureRoomId];
            if (connectedCount === undefined)
                connectedCount = 0;

            return (<tr key={x.fixtureRoomId}>
                <td>{x.fixtureName}</td>
                <td>{x.kickoffTimeString}</td>
                <td>{x.createdAtString}</td>
                <td>{x.tags ? x.tags.map(x => <Badge key={x.text} className="ml-1"
                                                     variant={x.variant}>{x.text}</Badge>) : []}</td>
                <td>
                    <Button size="sm" variant="outline-primary" onClick={(clickInfo) => {
                        props.history.push(`/scoring/${x.fixtureRoomId}`);
                    }}>Join</Button>
                    
                    <Button size="sm"
                            variant="outline-info"
                            className="ml-2"
                            onClick={async () => {
                                setSelectedFixture(x);
                                setShow(true);
                            }}>Details</Button>

                    <Button size="sm" variant="outline-info" className="ml-2" onClick={() => {
                        props.history.push(`/scoring/${x.fixtureRoomId}/review?roomActive=true`);
                    }}>Review</Button>
                </td>
            </tr>);
        }));

        return (
            <div style={{
                overflowY: 'scroll',
                overflowX: 'scroll',
                whiteSpace: 'nowrap',
                maxHeight: 'calc(100vh - 180px)'
            }}>
                <Table striped bordered hover className="react-bootstrap-table">
                    <thead>
                    <tr>
                        <th>Fixture</th>
                        <th>Fixture Date</th>
                        <th>Live At</th>
                        <th>Tags</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {content}
                    </tbody>
                </Table>
            </div>
        );
    };

    let contents = loading ? <p><em>Loading...</em></p> : renderTable(liveRooms);

    let modal = renderModal();

    return (
        <div>
            <h1 id="tabelLabel">Live Matches</h1>
            {contents}

            {modal}
        </div>
    );
}

LiveRooms.displayName = LiveRooms.name;

export default LiveRooms;